var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tongbuketang-page"},[_c('navBar',{on:{"goBack":_vm.gobackMoudle}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_c('vidoeList2')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }